/* app/js/src/components/publishing-status/publishing-status-container/publishing-status-container.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.publishing-status-scroll::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.publishing-status-scroll::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.publishing-status-scroll::-webkit-scrollbar-corner {
  background: transparent;
}
.publishing-status-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.publishing-status-scroll::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.publishing-status-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.publishing-status-scroll::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.publishing-status-scroll::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
@keyframes cs-pub-catalog-overlay-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
}
.publishing-status-container {
  flex: 1;
  min-height: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  background-color: rgb(235, 240, 244);
}
.publishing-status-header {
  flex-shrink: 0;
  padding: 16px 20px;
  background-color: rgb(255, 255, 255);
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
}
.publishing-status-content {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.publishing-status-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.publishing-status-scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
.publishing-status-loading,
.publishing-status-error {
  padding: 24px;
  text-align: center;
  color: rgba(0, 0, 0, 0.54);
}
.publishing-status-error button {
  margin-top: 12px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border: 1px solid rgb(45, 187, 252);
  border-radius: 6px;
  background: transparent;
  color: rgb(45, 187, 252);
  cursor: pointer;
}
.publishing-status-error button:hover {
  background: rgba(45, 187, 252, 0.08);
}
/*# sourceMappingURL=publishing-status-container.component.css.map */
